import React from "react";
import { Route, Switch } from "react-router-dom";
import ContractTemplateDetail from "./containers/Page/Detail/index";
import ContractTemplateList from "./containers/Report/index";
import NewTemplateContract from "./containers/Page/Create";
import NewContract from "./containers/Page/New";
import ContractTemplateEdit from "./containers/Page/Edit";

import ContractsRegularList from "./containers/ReportAll";
import ContractsRegularDetail from "./containers/Page/DetaillAll";
import ContractsRegularEdit from "./containers/Page/EditAll";

import Department from "./containers/ReportDepartment";
import NewLinkedContract from "./containers/Page/NewLinkedContract";
import ContractSolicitationList from "./containers/Page/ContractSolicitationList";
import ContractSolicitationSelection from "./containers/Page/ContractSolicitationSelection";
import NewSolicitationContract from "./containers/Page/NewSolicitationContract";
import NewBulkContractSolicitation from "./containers/Page/NewBulkContractSolicitation";
import ContractSolicitationCompleted from "./containers/Page/ContractSolicitationCompleted";
import ContractSolicitationDetail from "./containers/Page/ContractSolicitationDetail";
import ContractSolicitationEdit from "./containers/Page/ContractSolicitationEdit";
import JotaChat from "components/JotaChat";

const routes = () => {
	return (
		<React.Fragment>
			<Switch>
				<Route
					exact
					path="/contracts/template/new"
					component={NewTemplateContract}
				/>
				<Route
					exact
					path="/contracts/template"
					component={ContractTemplateList}
				/>
				<Route
					exact
					path="/contracts/template/:id"
					component={ContractTemplateDetail}
				/>
				<Route
					exact
					path="/contracts/template/:id/edit"
					component={ContractTemplateEdit}
				/>
				<Route exact path="/contracts/department" component={Department} />

				<Route exact path="/contracts" component={ContractsRegularList} />
				<Route exact path="/contracts/new" component={NewContract} />
				<Route
					exact
					path="/contracts/new-linked-contract/:id"
					component={NewLinkedContract}
				/>
				<Route
					exact
					path="/contracts/contract-solicitation"
					component={ContractSolicitationList}
				/>
				<Route
					exact
					path="/contracts/contract-solicitation-selection"
					component={ContractSolicitationSelection}
				/>
				<Route
					exact
					path="/contracts/contract-solicitation/new"
					component={NewSolicitationContract}
				/>
				<Route
					exact
					path="/contracts/bulk-contract-solicitation/new"
					component={NewBulkContractSolicitation}
				/>
				<Route
					exact
					path="/contracts/contract-solicitation-completed"
					component={ContractSolicitationCompleted}
				/>
				<Route
					exact
					path="/contracts/contract-solicitation/:id"
					component={ContractSolicitationDetail}
				/>
				<Route
					exact
					path="/contracts/contract-solicitation/:id/edit"
					component={ContractSolicitationEdit}
				/>
				<Route exact path="/contracts/:id" component={ContractsRegularDetail} />
				<Route
					exact
					path="/contracts/:id/edit"
					component={ContractsRegularEdit}
				/>
			</Switch>
			<JotaChat />
		</React.Fragment>
	);
};

export default routes;
